import { TableBodyStyled, TableHeadStyled } from 'components'
import styled from 'styled-components'

export const TableHead = styled(TableHeadStyled)`
  th:first-child {
    padding-left: 4px;
  }
`

export const TableBody = styled(TableBodyStyled)`
  td:first-child {
    padding-left: 4px;
  }
`
